import { trackEventFirebaseService } from 'analytics';
import Sentry from 'util/sentry';

const handleDownload = async (event, params = {}, showErrorModal) => {
    try {
        const { file } = params
        const { url, tag, id } = file

        if (!url) {
            return false
        }

        const date = new Date()
        const fileName = `${tag}_${id}_${Math.floor(date.getTime() + date.getSeconds() / 2)}.pdf`

        const response = await fetch(url)

        if (!response.ok) {
            throw new Error(`Download failed with status ${response.status}`)
        }

        const fileData = await response.blob()

        const downloadUrl = URL.createObjectURL(fileData)
        const link = document.createElement('a')
        link.href = downloadUrl
        link.download = fileName
        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()
        link.remove()

        window.URL.revokeObjectURL(downloadUrl)

        trackEventFirebaseService(event, params)
        return true
    } catch (err) {
        if (showErrorModal) showErrorModal()
        Sentry.captureException(err, { 
            message: 'Error al descargar el archivo en la función handleDownload', 
            extra: { params } 
        })
        return false
    }
}

export default handleDownload
